import { Component, input } from '@angular/core';
import { LpCanvasMapComponent } from '@features/lp/lp-canvas-map/lp-canvas-map.component';
import { LpClassicMapComponent } from '@features/lp/lp-classic-map/lp-classic-map.component';
import { LpMap } from '@typings/lp/generated';

@Component({
  selector: 'lp-map',
  imports: [LpCanvasMapComponent, LpClassicMapComponent],
  templateUrl: './lp-map.component.html',
  styleUrl: './lp-map.component.css',
})
export class LpMapComponent {
  map = input.required<LpMap>();
}
